import _ from 'lodash';
import { UPDATE_FILTER, RESET_FILTER } from "../actions/filters";
import { GET_USER_INFO_SUCCESS } from '../actions/settings';
import { USER_LOGOUT, CHANGE_USER_ATTRIBUTE_SUCCESS } from "../actions/auth";

// const initialState = {
//   contentTypes: [],
//   funnelStage: null,
//   gridStyle: 0,
//   isFavorite: false,
//   isPopular: false,
//   isVoted: false,
//   orderType: null
// };

const initialState = {
  updated: false
};

const FiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FILTER:
      return {
        ...state,
        ...action.filters,
        updated: action.isReset && Object.keys(action.filters || {}).includes('funnelStages')
      };
    case GET_USER_INFO_SUCCESS:
      let advancedFilters = {};
      if (_.get(action.user, 'searchOptions', null) && state.funnelStages === undefined) {
        advancedFilters = {
          funnelStages: [],
          contentTypes: [],
          contentTags: _.get(action.user, 'searchOptions.tags', []),
          contentRegions: _.get(action.user, 'searchOptions.regions', []),
          contentProducts: _.get(action.user, 'searchOptions.products', []),
          contentIndustries: _.get(action.user, 'searchOptions.industries', [])
        }
      }

      return {
        ...state,
        ...advancedFilters
      };
    case CHANGE_USER_ATTRIBUTE_SUCCESS: {
      if (action.params.name === 'searchOptions' && !state.updated) {
        const advancedFilters = {
          funnelStages: [],
          contentTypes: [],
          contentTags: _.get(action.params.value, 'tags', []),
          contentRegions: _.get(action.params.value, 'regions', []),
          contentProducts: _.get(action.params.value, 'products', []),
          contentIndustries: _.get(action.params.value, 'industries', [])
        };

        return {
          ...state,
          ...advancedFilters
        };
      }

      return {
        ...state
      };
    }
    case RESET_FILTER:
      return {
        gridStyle: state.gridStyle || 0,
        updated: false
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
}

export default FiltersReducer;
